export default [
  { slug: 'bet365', image: '/images/merchants/bet365.svg' },
  { slug: 'blaze', image: '/images/merchants/blaze.svg' },
  { slug: 'superbet', image: '/images/merchants/superbet.svg' },
  { slug: 'betfair', image: '/images/merchants/betfair.svg' },
  { slug: 'estrela-bet', image: '/images/merchants/estrelabet.svg' },
  { slug: 'stake', image: '/images/merchants/stake.svg' },
  { slug: 'sportingbet', image: '/images/merchants/sportingbet.svg' },
];
